var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    产品业务知识库，开发中，即将上线。\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }